import { IGeofence } from "@app/interfaces/IGeofences";
import { ISummaryHistogram } from "@directives/_visualisations/listogram/listogram.component";
import { IPlot } from "@interfaces/IPlot";
import { IVehicle } from "@interfaces/IVehicle";
import { ColourService } from "@services/colour.service";
import { GeofenceService, IGeofenceVisit } from "@services/geofence.service";
import * as angular from "angular";
import "./vehicleSummaryStatistics.scss";

interface IVehicleSummaryStatisticsController {
    vehicle: IVehicle;
}

class VehicleSummaryStatisticsController implements angular.IComponentController, IVehicleSummaryStatisticsController {

    loading: boolean;

    vehicle: IVehicle;
    plots: IPlot[];

    geofenceVisits: IGeofenceVisit[] = [];
    geofences: IGeofence[] = [];
    geofenceVisitHistogram: ISummaryHistogram<IGeofenceVisit>[] = [];

    geofenceVisitVsUnknownHistogram: ISummaryHistogram<any>[] = [];
    vehicleUtilisationHistogram: ISummaryHistogram<string>[] = [];
    unknownLocationsHistogram: ISummaryHistogram<any>[] = [];

    static $inject = ["$q", "colourService", "geofenceService"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly colourService: ColourService,
        private readonly geofenceService: GeofenceService) {
    }

    $onInit() {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {

        if (onChangesObj["plots"]) {
            this.updateListograms();
        }
    }

    private updateListograms() {
        this.geofenceVisits = [];

        this.geofenceVisitHistogram = [];
        this.geofenceVisitVsUnknownHistogram = [];
        this.unknownLocationsHistogram = [];

        if (!this.plots || this.plots.length == 0) {
            //console.log("aborting");
            return;
        }

        this.loading = true;
        this.updateGeofenceVisits()
            .finally(() => {
                this.createUnknownPlacesHistogram(this.plots);

                this.loading = false;
            });
    }

    private createUnknownPlacesHistogram(plots: IPlot[]) {
        var placeArray: string[] = [];
        var lastPlot: IPlot = plots[0];

        plots.forEach(plot => {

            if (plot?.LocationInformation?.GeofenceIds?.length === 0 && plot !== lastPlot) {
                var timeSinceLastPlot = plot.UtcMoment.diff(lastPlot.UtcMoment, "s") / 60;

                // Remove digits i.e. 22 not M1
                var parsedAddress = lastPlot?.LocationInformation.LocationDescription.replace(/\b\d+\b/g, '')

                // Remove non alphernumerics from start and end
                parsedAddress = parsedAddress.replace(/^[^a-zA-Z0-9]*|[^a-zA-Z0-9]*$/g, '');

                // Trim :)
                parsedAddress = parsedAddress.trim();

                if (!placeArray[parsedAddress]) {
                    placeArray[parsedAddress] = 0;
                }

                placeArray[parsedAddress] += timeSinceLastPlot;
            }

            lastPlot = plot;
        });

        placeArray = placeArray.sort((a, b) => {
            alert(a);
            return placeArray[a] - placeArray[b];
        });

        var sortedLocations = Object.keys(placeArray)
            .map(c => ({ key: c, value: placeArray[c] }))
            .sort((a, b) => b.value - a.value)

        var topLocations = sortedLocations.slice(0, 5);

        var totalUnknownLocationsTime = 0;
        sortedLocations.forEach(loc => { totalUnknownLocationsTime += loc.value });

        this.unknownLocationsHistogram = [];

        topLocations.forEach((loc, i) => {
            this.unknownLocationsHistogram.push({
                id: i,
                color: this.colourService.getColour(i, true).solidColour,
                description: loc.key,//`Near ${loc.key}`,
                duration: loc.value,
                count: 1,
                percentage: loc.value * 100 / totalUnknownLocationsTime,
                object: loc
            });
        });
    }

    private updateGeofenceVisits(): angular.IPromise<any> {

        const geofenceVisitPromise = this.geofenceService
            .getGeofenceVisitsByVehicle(this.vehicle.Id, this.plots[0].UtcMoment, this.plots[this.plots.length - 1].UtcMoment);
        const geofencePromise = this.geofenceService.getGeofences();

        return this.$q.all([geofenceVisitPromise, geofencePromise])
            .then(([geofenceVisits, geofences]) => {
                this.geofenceVisits = geofenceVisits;
                this.geofences = geofences;

                this.createGeofenceVisitHistogram();
                this.createGeofenceVsUnknownHistogram();
            });
    }

    private createGeofenceVisitHistogram() {
        this.geofenceVisitHistogram = [];

        var i = 0;
        var totalDuration = 0;

        this.geofenceVisits.forEach(visit => {
            totalDuration += visit.duration;
        });

        this.geofenceVisits.forEach((visit, i) => {
            var anyVisit = visit as any;

            var visitHistogram = this.findExistingHistogram<IGeofenceVisit>(visit.GeofenceId, this.geofenceVisitHistogram);

            if (!visitHistogram) {

                visitHistogram = {
                    id: visit.GeofenceId,
                    description: this.geofenceService.findGeofence(this.geofences, visit.GeofenceId).Description,
                    object: visit,
                    duration: visit.duration,
                    color: this.colourService.getColour(i, true).solidColour,
                    count: 1,
                    percentage: 0
                };

                this.geofenceVisitHistogram.push(visitHistogram);
            }
            else {
                visitHistogram.duration += visit.duration;
                visitHistogram.count++;
            }

            visitHistogram.percentage = visitHistogram.duration * 100 / totalDuration;
        });
    }

    private createGeofenceVsUnknownHistogram() {
        this.geofenceVisitVsUnknownHistogram = [];

        var totalGeofenceVisitDuration = 0;
        var totalPlotDuration = 24 * 60;

        this.geofenceVisits.forEach(visit => {
            totalGeofenceVisitDuration += visit.duration;
        });

        this.geofenceVisitVsUnknownHistogram.push({
            color: this.colourService.getColour(0, true).solidColour,
            id: 0,
            description: "Inside Geofences",
            count: 0,
            duration: totalGeofenceVisitDuration,
            percentage: totalGeofenceVisitDuration * 100 / totalPlotDuration,
            object: null
        });

        this.geofenceVisitVsUnknownHistogram.push({
            color: this.colourService.getColour(1, true).solidColour,
            id: 0,
            description: "Outside Geofences",
            count: 0,
            duration: totalPlotDuration - totalGeofenceVisitDuration,
            percentage: (totalPlotDuration - totalGeofenceVisitDuration) * 100 / totalPlotDuration,
            object: null
        });
    }

    private findExistingHistogram<T>(id: number, histogramArray: ISummaryHistogram<T>[]): ISummaryHistogram<T> {
        var histogram: ISummaryHistogram<T>;

        histogramArray.forEach(hg => {
            if (hg.id == id) {
                histogram = hg;
            }
        });

        return histogram;
    }
}

export class VehicleSummaryStatisticsComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    transclude: boolean;

    constructor() {
        this.bindings = {
            vehicle: "<",
            plots: "<",
        };

        this.transclude = true;

        this.controller = VehicleSummaryStatisticsController;
        this.template = require("./vehicleSummaryStatistics.html");
    }
}
